export default __webpack_public_path__ + "static/media/bw-name.935e5ccc.svg";